import Shape from './Shape';
import Coords from '../Util/Coords';

export default class Rectangle extends Shape {

    constructor(p1, p2) {
        super();
        this.point1 = p1;
        this.point2 = p2;
    }

    isShape() {
        return true;
    }

    export() {
        return {
            id: this.id,
            type: 'rectangle',
            layer: this.layer,
            point1: this.point1,
            point2: this.point2,
            props: this.props.export('rectangle'),
        }
    }

    updateProp(key, value) {
        if (key === 'point1') {
            this.point1 = value;
        } else if (key === 'point2') {
            this.point2 = value;
        }
    }

    isHover (point) {
        if (point[0] >= Math.min(this.point1[0], this.point2[0]) && 
            point[0] <= Math.max(this.point1[0], this.point2[0]) && 
            point[1] >= Math.min(this.point1[1], this.point2[1]) && 
            point[1] <= Math.max(this.point1[1], this.point2[1])
        ) {
            return this.id;
        }

        return false;
    }

    isHoverPoint(p, props) {
        let p1 = Coords.toView(this.point1, props.viewCenter, props.lookingAt, props.tileSize);
        let p2 = Coords.toView(this.point2, props.viewCenter, props.lookingAt, props.tileSize);

        let p1a = p[0] - p1[0];
        let p1b = p[1] - p1[1];
        let p2a = p[0] - p2[0];
        let p2b = p[1] - p2[1];

        if (Math.sqrt(p1a*p1a + p1b*p1b) < 12) {
            return 'point1';
        }

        if (Math.sqrt(p2a*p2a + p2b*p2b) < 12) {
            return 'point2';
        }

        return false;
    }

    isUnderSelection(bounds) {
        return Coords.inRect(this.point1, bounds) && Coords.inRect(this.point2, bounds);
    }

    getMoveableProps() {
        return [this.point1, this.point2];
    }

    relativeMove(point, origin, initialState) {
        let dx = point[0] - origin[0];
        let dy = point[1] - origin[1];

        this.updateProp('point1', [initialState[0][0] + dx, initialState[0][1] + dy]);
        this.updateProp('point2', [initialState[1][0] + dx, initialState[1][1] + dy]);
    }

    draw(props) {
        let p1 = Coords.toView(this.point1, props.viewCenter, props.lookingAt, props.tileSize);
        let p2 = Coords.toView(this.point2, props.viewCenter, props.lookingAt, props.tileSize);

        if (!props.hover) {
            this.ctx.strokeStyle = '#1e1e1e';
            this.ctx.lineWidth = 3;
        } else {
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = 6;
        }
        this.ctx.fillStyle = this.props.color;

        this.ctx.strokeRect(p1[0], p1[1], p2[0]-p1[0], p2[1]-p1[1]);
        this.ctx.fillRect(p1[0], p1[1], p2[0]-p1[0], p2[1]-p1[1]);

        if (props.hover) {
            this.ctx.fillStyle = '#0ff';
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = 6;

            this.ctx.fillRect(p1[0]-5, p1[1]-5, 10, 10);
            this.ctx.strokeRect(p1[0]-5, p1[1]-5, 10, 10);

            this.ctx.fillRect(p2[0]-5, p2[1]-5, 10, 10);
            this.ctx.strokeRect(p2[0]-5, p2[1]-5, 10, 10);
        }
    }

}